import * as d3 from "d3";
import {showLabel} from "../RadarChart.functions";
import {SidebarTab} from "../../Sidebar";
import {ITypeRadar} from "../../../types";
import {xScale} from "../../../mocks/projectsMock";

interface ClusterPointProps {
  cluster: any;
  xStart: number;
  yStart: number;
  xEnd: number;
  yEnd: number;
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>;
  segmentColor: {back: string; color: string};
  innerColor: {back: string; color: string};
  isActiveCluster: boolean;
  showAllLabels: boolean;
  openSidebarWithTab: (
    tab: any,
    directionId: number,
    clusterId: number,
    name: string,
    sectionName: string,
    colorTitle: {back: string; color: string}
  ) => void;
  typeRadar: ITypeRadar;
  sectionName: string;
  setFocusPosition: (position: {x: number; y: number}) => void;
  isWeak_signal?: boolean;
  scale: number;
  hideLabel: () => void;
  isNationalProjects?: boolean;
  backColor?: string;
  isEditMode?: boolean;
  onPositionChange?: (id: number | string, x: number, y: number) => void;
  segmentCenterAngle?: number;
  availableAngle?: number;
  minRadius?: number;
  maxRadius?: number;
}

const cutTitle = (title: string, scale: number) => {
  if (scale && scale <= 3.3) {
    const words = title.split(/[\s.,]+/);
    const limit = 15;
    let truncatedTitle = "";
    let charCount = 0;

    for (const word of words) {
      if (charCount + word.length > limit) {
        if (words.indexOf(word) < words.length - 1) {
          truncatedTitle += word + "...";
        } else {
          truncatedTitle += word;
        }
        break;
      }
      truncatedTitle += word + " ";
      charCount += word.length + 1;
    }

    return truncatedTitle.trim();
  }
  return title;
};

const renderClusterPoint = ({
  cluster,
  xStart,
  yStart,
  xEnd,
  yEnd,
  mainGroup,
  segmentColor,
  innerColor,
  isActiveCluster,
  showAllLabels,
  openSidebarWithTab,
  typeRadar,
  sectionName,
  setFocusPosition,
  isWeak_signal,
  scale,
  hideLabel,
  isNationalProjects,
  backColor,
  isEditMode,
  onPositionChange,
  segmentCenterAngle,
  availableAngle,
  minRadius,
  maxRadius,
}: ClusterPointProps) => {
  const clusterPoint = mainGroup.append("g");
  // const hoverColor = segmentColor.replace("0.5", "1");
  const hoverColor = segmentColor;

  const originalColor = d3.hsl(hoverColor.back);
  // const hslColor = originalColor?.hsl();
  originalColor.l -= 0.1; // lighten by 20%
  const darkerColor = originalColor.toString();

  const circleRadius = Math.min(Math.max(4, cluster.size), 8);
  const circleRadiusInner = circleRadius * 0.75;
  clusterPoint
    .append("circle")
    .attr("cx", xStart)
    .attr("id", `outline-circle-${cluster.id}`)
    .attr("cy", yStart)
    .attr("r", circleRadius * xScale)
    .style(
      "fill",
      isNationalProjects ? backColor ?? hoverColor.back : hoverColor.back
    )
    .style("opacity", 0.5)
    .style("stroke", "none")
    .on("mouseover", function () {
      d3.select(this.parentNode as Element).raise();
    })
    .on("mouseout", function () {
      if (isActiveCluster) return;
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 0);
    })
    .on("mouseenter", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)

        .style("opacity", 1);
    })
    .on("mouseleave", function () {
      if (!isActiveCluster) {
        d3.select(this).style(
          "fill",
          isNationalProjects ? backColor ?? hoverColor.back : hoverColor.back
        );
      }
    });

  clusterPoint
    .append("circle")
    .attr("id", `outline-inner-circle-${cluster.id}`)
    .attr("cx", xStart)
    .attr("cy", yStart)
    .attr("r", circleRadiusInner * xScale)
    .style("fill", "white")
    .style("stroke", "none")
    .style("opacity", isActiveCluster ? 1 : 0)
    .style("cursor", "pointer")
    .on("mouseover", function () {
      d3.select(this).style("opacity", 1);
      d3.select(this.parentElement)
        .select(`#outline-circle-${cluster.id}`)
        .style(
          "fill",
          isNationalProjects ? backColor ?? hoverColor.back : hoverColor.back
        );
    })
    .on("mouseout", function () {
      if (isActiveCluster) return;
      d3.select(this).style("opacity", 0);
    })
    .on("click", () => {
      if (isEditMode) return;
      openSidebarWithTab(
        typeOpenCard,
        cluster.direction_id,
        cluster.id,
        cluster.name,
        sectionName,
        innerColor
      );
      // if (xStart && yStart) setFocusPosition({x: xStart, y: yStart});
    })

    .on("mouseenter", function () {
      if (isActiveCluster) return;
      if (!showAllLabels) {
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          true,
          false,
          false,
          0,
          0,
          0,
          isNationalProjects,
          backColor || "#fff"
        );
      }
      if (showAllLabels) {
        mainGroup
          .select(`.tooltip-background-cluster${cluster.id}`)
          .attr("opacity", 0);
        // .attr("stroke", "#fff")
        // .attr("stroke-width", 0.4)
        // .attr("stroke-opacity", 0.8);
        mainGroup
          .selectAll(`.tooltip-text-cluster${cluster.id}`)
          .attr("opacity", 0);

        // mainGroup
        //   .selectAll(
        //     `.tooltip-background-cluster${cluster.id}, .tooltip-text-cluster${cluster.id}`
        //   )
        //   .raise();

        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          true,
          false,
          false,
          0,
          0,
          0,
          isNationalProjects,
          backColor || "#fff"
        );
      }
    })
    .on("mouseleave", function () {
      if (isActiveCluster) return;
      hideLabel();
      if (showAllLabels) {
        // mainGroup
        //   .select(`.tooltip-background-cluster${cluster.id}`)
        //   .attr("opacity", 0.8)
        //   .attr("stroke-opacity", 0);
        // mainGroup
        //   .selectAll(`.tooltip-text-cluster${cluster.id}`)
        //   .attr("opacity", 0.6);
        mainGroup
          .selectAll(`.tooltip-background-cluster${cluster.id}`)
          .attr("opacity", 0);

        mainGroup
          .selectAll(`.tooltip-text-cluster${cluster.id}`)
          .attr("opacity", 0);

        if (scale <= 1.6 && cluster.size < 4 && typeRadar === "map") {
          hideLabel();
          return;
        }

        if (
          scale >= 1.6 &&
          scale <= 3.2 &&
          cluster.size < 3 &&
          typeRadar === "map"
        ) {
          hideLabel();
          return;
        }
        showLabel(
          typeRadar === "map" ? cutTitle(cluster.name, scale) : cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          isActiveCluster ? true : false,
          false,
          false,
          0,
          0,
          0,
          isNationalProjects,
          backColor || "#fff"
        );
      }
    });
  let typeOpenCard: SidebarTab;
  switch (typeRadar) {
    case "map":
      typeOpenCard = SidebarTab.CPU;
      break;
    case "esg":
      typeOpenCard = SidebarTab.Projects;
      break;
    case "fintech":
      if (!isWeak_signal) {
        typeOpenCard = SidebarTab.Trends;
      } else {
        typeOpenCard = SidebarTab.WeakSignal;
      }
      break;
    case "stateInitiative":
      typeOpenCard = SidebarTab.StateInitiative;
      break;
    default:
      typeOpenCard = SidebarTab.CPU;
  }
  clusterPoint
    .append("circle")
    .attr("id", `inline-circle-${cluster.id}`)
    .attr("cx", xStart)
    .attr("cy", yStart)
    .attr("r", (circleRadiusInner - 0.5) * xScale)
    .style(
      "fill",
      isNationalProjects ? backColor ?? hoverColor.back : innerColor.back
    )
    .style("stroke", "none")
    .style("stroke-width", 0.5)
    .style("cursor", "pointer")
    .on("mouseover", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 1);
    })
    .on("mouseout", function () {
      if (isActiveCluster) return;
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 0);
    })
    .on("mouseenter", function () {
      if (isActiveCluster) return;
      d3.select(this).style("border-radius", "1px");

      hideLabel();
      if (!showAllLabels) {
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          true,
          false,
          false,
          0,
          0,
          0,
          isNationalProjects,
          backColor || "#fff"
        );
      }
      if (showAllLabels) {
        mainGroup
          .select(`.tooltip-background-cluster${cluster.id}`)
          .attr("opacity", 0);
        // .attr("stroke", "#fff")
        // .attr("stroke-width", 0.4)
        // .attr("stroke-opacity", 0.8);
        mainGroup
          .selectAll(`.tooltip-text-cluster${cluster.id}`)
          .attr("opacity", 1)
          .attr("fill", innerColor.color);

        // mainGroup
        //   .selectAll(
        //     `.tooltip-background-cluster${cluster.id}, .tooltip-text-cluster${cluster.id}`
        //   )
        //   .raise();

        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          true,
          false,
          false,
          0,
          0,
          0,
          isNationalProjects,
          backColor || "#fff"
        );
      }
    })
    .on("click", () => {
      if (isEditMode) return;
      openSidebarWithTab(
        typeOpenCard,
        cluster.direction_id,
        cluster.id,
        cluster.name,
        sectionName,
        innerColor
      );
      // if (xStart && yStart) setFocusPosition({x: xStart, y: yStart});
    })
    .on("mouseleave", function () {
      if (isActiveCluster) return;
      if (!showAllLabels) {
        hideLabel();
      }
      if (showAllLabels) {
        // mainGroup
        //   .select(`.tooltip-background-cluster${cluster.id}`)
        //   .attr("opacity", 0.8)
        //   .attr("stroke-opacity", 0);
        // mainGroup
        //   .selectAll(`.tooltip-text-cluster${cluster.id}`)
        //   .attr("opacity", 0.6);

        // mainGroup
        //   .select(`.tooltip-background-cluster${cluster.id}`)
        //   .attr("opacity", 0.8)
        //   .attr("stroke-opacity", 0);
        // mainGroup
        //   .selectAll(`.tooltip-text-cluster${cluster.id}`)
        //   .attr("opacity", 0.6);
        mainGroup
          .selectAll(`.tooltip-background-cluster${cluster.id}`)
          .attr("opacity", 0);
        mainGroup
          .selectAll(`.tooltip-text-cluster${cluster.id}`)
          .attr("opacity", 0);

        if (scale <= 1.6 && cluster.size < 4 && typeRadar === "map") {
          hideLabel();
          return;
        }

        if (
          scale >= 1.6 &&
          scale <= 3.2 &&
          cluster.size < 3 &&
          typeRadar === "map"
        ) {
          hideLabel();
          return;
        }
        showLabel(
          typeRadar === "map" ? cutTitle(cluster.name, scale) : cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          false,
          false,
          false,
          0,
          0,
          0,
          isNationalProjects,
          backColor || "#fff"
        );
      }
    });

  if (isActiveCluster) {
    showLabel(
      cluster.name,
      xStart,
      yStart,
      mainGroup,
      cluster.id,
      "cluster",
      innerColor,
      showAllLabels,
      typeRadar,
      scale,
      undefined,
      true,
      false,
      false,
      0,
      0,
      0,
      isNationalProjects,
      backColor || "#fff"
    );
    // setFocusPosition({x: xStart, y: yStart});
  }

  if (showAllLabels) {
    if (scale <= 1.6 && cluster.size < 4 && typeRadar === "map") return;
    if (scale > 1.6 && scale <= 3.3 && cluster.size < 3 && typeRadar === "map")
      return;

    showLabel(
      typeRadar === "map" ? cutTitle(cluster.name, scale) : cluster.name,
      xStart,
      yStart,
      mainGroup,
      cluster.id,
      "cluster",
      innerColor,
      showAllLabels,
      typeRadar,
      scale,
      undefined,
      isActiveCluster ? true : false,
      false,
      false,
      0,
      0,
      0,
      isNationalProjects,
      backColor || "#fff"
    );
  }

  if (isEditMode && onPositionChange) {
    clusterPoint.style("cursor", "grab");

    const drag = d3
      .drag<SVGGElement, unknown>()
      .on("start", function (event) {
        event.sourceEvent.stopPropagation();
        d3.select(this).raise().style("cursor", "grabbing");
        hideLabel();
      })
      .on("drag", function (event) {
        d3.select(this)
          .selectAll("circle")
          .attr("cx", event.x)
          .attr("cy", event.y);
      })
      .on("end", function (event) {
        d3.select(this).style("cursor", "grab");

        const cx = event.x;
        const cy = event.y;
        const angleDeg = Math.atan2(cy, cx) * (180 / Math.PI);
        const radius = Math.sqrt(cx * cx + cy * cy);

        const physicalGap = 6;
        const angularPadding = (physicalGap / Math.max(radius, 1)) * (180 / Math.PI);
        const half = (availableAngle ?? 360) / 2 - angularPadding;
        const center = segmentCenterAngle ?? angleDeg;
        let angleDiff = angleDeg - center;
        while (angleDiff > 180) angleDiff -= 360;
        while (angleDiff < -180) angleDiff += 360;
        const clampedAngleDeg = center + Math.max(-half, Math.min(half, angleDiff));
        const clampedRadius = Math.max(
          minRadius ?? 0,
          Math.min(maxRadius ?? 1000, radius)
        );

        const clampedX =
          clampedRadius * Math.cos((clampedAngleDeg * Math.PI) / 180);
        const clampedY =
          clampedRadius * Math.sin((clampedAngleDeg * Math.PI) / 180);

        d3.select(this)
          .selectAll("circle")
          .attr("cx", clampedX)
          .attr("cy", clampedY);

        onPositionChange(cluster.id, clampedX, clampedY);
      });

    clusterPoint.call(drag);
  }

  return null;
};

export default renderClusterPoint;
